import { Pencil } from 'lucide-react';
import LangEnum from '../../../../../../lang/LangEnum';
import OrderSummaryActionButton from './OrderSummaryActionButton';
import { useEditOrderInBrandButton } from './hooks/useEditOrderInBrandButton';

const EditOrderInBrandButton = () => {
  const { isButtonVisible, handleClick } = useEditOrderInBrandButton();

  if (!isButtonVisible) {
    return null;
  }

  return (
    <OrderSummaryActionButton
      label={LangEnum.ORDER_FINISHED_EDIT_ORDER_ACTION_LABEL}
      ActionIcon={Pencil}
      onClick={handleClick}
    />
  );
};

export default EditOrderInBrandButton;
